module.exports = __webpack_public_path__ + "static/media/buying_btn.png";